import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Spin, Select } from "antd";
import { ReactSVG } from "react-svg";
import { getTranslation } from "../../../utils/helper";

const CompaniesFilterForm = ({ setting, isFetching, query, onSubmit, companies = [] }) => {
  const [form] = Form.useForm();

  const companyNameField = "name";
  const companyNameValue = query[companyNameField];

  const brandingField = "accountType";
  const brandingValue = query[brandingField];

  const companyPartnerIdField = "companyPartnerId";
  const companyPartnerIdValue = query[companyPartnerIdField];

  const partnerEmailField = "companyAdminEmail";
  const partnerEmailIdValue = query[partnerEmailField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    values[companyNameField] = companyNameValue;
    values[brandingField] = brandingValue;
    values[companyPartnerIdField] = companyPartnerIdValue;
    values[partnerEmailField] = partnerEmailIdValue;
    return values;
  };

  const handleSubmit = values => {
    const params = {};
    params[companyNameField] = values[companyNameField] || null;
    params[brandingField] = values[brandingField] || null;
    params[companyPartnerIdField] = values[companyPartnerIdField] || null;
    params[partnerEmailField] = values[partnerEmailField] || null;
    onSubmit({ ...query, ...params, currentPage: 1 }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={initialValues}
        className="FilterForm CompaniesFilterForm"
        layout="vertical">
        <div className="FilterFormContent">
          <Row gutter={16}>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Companies", "Company Name")} name={companyNameField}>
                <Input size="large" placeholder="Company Name" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item
                label={getTranslation(setting, "Companies", "Company Partner Name")}
                name={companyPartnerIdField}>
                <Select
                  size="large"
                  label={getTranslation(setting, "Companies", "Company Partner Name")}
                  placeholder={getTranslation(setting, "Companies", "Company Partner Name")}
                  showArrow
                  style={{ width: "100%" }}>
                  {companies.map(company => (
                    <Select.Option key={company._id} value={company.id}>
                      {company.name}
                    </Select.Option>
                  ))}
                  ;
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Companies", "Company Admin Email")} name={partnerEmailField}>
                <Input size="large" placeholder="Company Admin Email" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
              <div className="FilterFormActions">
                <Button size="large" type="text" onClick={handleResetButton}>
                  {getTranslation(setting, "Common", "Reset")}
                  <ReactSVG className="icon" src="/icons/reset.svg" />
                </Button>
                <Button size="large" type="primary" htmlType="submit">
                  {getTranslation(setting, "Common", "Apply")}
                  <ReactSVG className="icon" src="/icons/apply.svg" />
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </Spin>
  );
};

export default CompaniesFilterForm;
